import {createUseStyles} from 'react-jss';
import {Theme} from './themes/default';

const bicycleGameStyles = createUseStyles((theme: Theme) => {
    return {
        gameContainer: {
            width: '100%',
            maxWidth: '1000px',
            margin: '0 auto',
            paddingBottom: '20px',
          },
          scoreText: {
            fontSize: '24px',
            marginTop: '20px',
            fontFamily: theme.fonts.poplar,
          },
          totalScoreText: {
            fontSize: '30px',
            marginBottom: '20px',
            color: '#4a4a4a',
            paddingTop: '20px',
            fontFamily: theme.fonts.poplar,
          },
          errorText: {
            color: 'red',
            marginBottom: '10px',
            fontFamily: theme.fonts.poplar,
          },
          nicknameForm: {
            display: 'flex',
            gap: '20px',
            padding: '20px',
            fontFamily: theme.fonts.poplar,
          },
          input: {
            //marginTop: theme.spacing(3),
            '& .MuiInputBase-root': {
                fontFamily: theme.fonts.apex,
                fontSize: '24px',
                lineHeight: 1,
                fontWeight: 'bold',
                borderRadius: theme.spacing(2),
                letterSpacing: '1px',
                backgroundColor: theme.palette.background.default,
                color: theme.palette.primary.main,
                [theme.breakpoints.down('sm')]: {
                    fontSize: '18px',
                    fontWeight: 'normal',
                },
            },
          },
          button: {
            fontFamily: theme.fonts.poplar,
            textTransform: 'uppercase',
            fontWeight: 500,
            //marginBottom: theme.spacing(3),
            color: theme.palette.primary.main,
            fontSize: 'max(1.3vh,1.3vw)',
            borderRadius: theme.spacing(2),
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            //marginTop: theme.spacing(-3),
            border: `3px solid ${theme.palette.primary.main}`,
            '&:hover': {
                color: theme.palette.primary.light,
            },
            // [theme.breakpoints.down('lg')]: {
            //     marginTop: theme.spacing(-5),
            // }
          },
          cooldownMessage: {
            color: theme.palette.primary.main,
            fontSize: '20px',
            marginBottom: '20px',
            fontWeight: 'medium',
            fontFamily: theme.fonts.apex,
          },
          whatsappButton: {
            cursor: 'pointer',
            transition: 'transform 0.2s ease',
        '&:hover': {
            transform: 'scale(1.1)',
        },
        '&:active': {
            transform: 'scale(0.95)',
        },
        },
      }
});

export default bicycleGameStyles;